/**
 * Author：brand
 * Creation Time：2019-05-13 18:06
 * Email：brandhuang@qq.com
 */
import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
   Cookies.set(TokenKey, token)
}

export function removeToken() {
    let allCookies = Cookies.get()
    for (let key in allCookies){
        Cookies.remove(key)
    }
}
